import { render } from "./Denied.vue?vue&type=template&id=efacfca2&scoped=true&ts=true"
import script from "./Denied.vue?vue&type=script&lang=ts"
export * from "./Denied.vue?vue&type=script&lang=ts"

import "./Denied.vue?vue&type=style&index=0&id=efacfca2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efacfca2"]])

export default __exports__